import React from 'react'
import { Link } from 'react-router-dom'
import { FormattedMessage, useIntl } from 'react-intl'
import { useAuth } from '../../contexts/AuthContext'
import { Button } from '../ui'
import Section from './Section'
import SectionTitle from './SectionTitle'
import { CONTACT, MAILTO } from '../../config/contact'

/**
 * Two ways forward. The conversation leads and the free trial follows it:
 * there is no reference customer yet, so a visitor left alone with the product
 * learns less than a visitor who talks to us, and we learn nothing at all.
 */
const CtaSection: React.FC = () => {
  const { user } = useAuth()
  const intl = useIntl()

  return (
    <Section bg="bg-primary/5" maxWidth="sm">
      <SectionTitle
        title={intl.formatMessage({ id: 'marketing.cta.title' })}
        subtitle={intl.formatMessage({ id: 'marketing.cta.subtitle' })}
      />
      <div className="text-center">
        {user ? (
          <Link to="/dashboard">
            <Button variant="primary" size="lg">
              <FormattedMessage id="marketing.hero.goToDashboard" />
            </Button>
          </Link>
        ) : (
          <>
            <div className="flex flex-col sm:flex-row gap-3 justify-center">
              <a href={CONTACT.bookingUrl} target="_blank" rel="noreferrer" className="w-full sm:w-auto">
                <Button variant="primary" size="lg" className="w-full sm:w-auto">
                  <FormattedMessage id="marketing.hero.talk" />
                </Button>
              </a>
              <Link to="/auth/signup" className="w-full sm:w-auto">
                <Button variant="outline" size="lg" className="w-full sm:w-auto">
                  <FormattedMessage id="marketing.hero.tryFree" />
                </Button>
              </Link>
            </div>
            <p className="mt-6 text-sm text-foreground-muted">
              <FormattedMessage
                id="marketing.cta.orEmail"
                values={{
                  email: (
                    <a href={MAILTO} className="text-primary hover:text-primary-dark">
                      {CONTACT.email}
                    </a>
                  ),
                }}
              />
            </p>
          </>
        )}
      </div>
    </Section>
  )
}

export default CtaSection
